import { fromJS } from 'immutable';

import { ApiDashboard,UserToken } from '../../../helper/HelperAuth'
import {GetHighestReadRate} from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'


export default (body, type=null) => async (dispatch, getState) => {

    const Authorization = UserToken;

    const url = ApiDashboard + 'highest-read-rate';

    var query = body

    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
            'template-type':type,

        },
        body : JSON.stringify(query)
    };

    const response = await doFetch(url,argument);
    var data = fromJS({});
    var responseData = [];
    var finalData = [];
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('highest-read-rate');
    }
    dispatch({ type: GetHighestReadRate, data: fromJS(data) });
    return data
};